import { XCircle } from "@phosphor-icons/react"
import { Note, Spinner } from "@vesatogo/grass-core"

export const NoCreditLimitNote = ({
  children,
  fetching = false,
}: {
  children?: any
  fetching?: boolean
}) => {
  return fetching ? (
    <div className="text-center">
      {" "}
      <Spinner />
    </div>
  ) : (
    <Note
      intent="danger"
      className="text-sm flex gap-2 items-center border-l-4 border-red-500 mt-3"
    >
      <XCircle weight="fill" className="text-red-500" size={18} />
      Credit limit not configured for this buyer. Please assign a limit to
      initiate transactions.
      {children}
    </Note>
  )
}
